import React from 'react';

export function EmptyWrapper({ children }: { children?: React.ReactNode }) {
  return <>{children}</>;
}
